/**
 * @Copyright (c) 2021 DigiNet
 * @author NHATLONG
 * @create 17/9/2021
 * @Example
 */

export const types = {
    W39F3036_LOAD_GRID: 'W39F3036_LOAD_GRID',
    W39F3036_LOAD_FORM: 'W39F3036_LOAD_FORM',
    W39F3036_SAVE: 'W39F3036_SAVE',
    W39F3036_EXPORT: 'W39F3036_EXPORT',
};

export function getGridData(params, cb) {
    return {
        type: types.W39F3036_LOAD_GRID,
        params,
        cb,
    };
}

export function getFormData(params, cb) {
    return {
        type: types.W39F3036_LOAD_FORM,
        params,
        cb,
    };
}

export function onSave(params, cb) {
    return {
        type: types.W39F3036_SAVE,
        params,
        cb,
    };
}

export function onExport(params, cb) {
    return {
        type: types.W39F3036_EXPORT,
        params,
        cb,
    };
}